import React from "react";
import {Button, Container, List, ListItem, ListItemIcon, ListItemText, SwipeableDrawer, withStyles} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {setLanguage} from "../redux/auth/actions";
import CloseIcon from '@material-ui/icons/Close';
import Divider from "@material-ui/core/Divider";
import { isIOS } from "react-device-detect";
import Logo from "../assets/icons/logo.png";
import NaviMenu from '../assets/icons/icon-navi-menu.png';
import ListItemLink from "./ListItemLink";
import CustomButton from "./CustomButton";
import DownloadIcon from "../assets/icons/icon-tool-download-2.png";

const APP_STORE_URL = 'https://itunes.apple.com/us/app/cardiogram/id1614912231?ls=1&mt=8';
const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=me.eztrust.pinkiiswear';

const useStyles = theme => ({
    menuList: {
        backgroundColor: 'white',
    },
    menuPaper: {
        height: '100%'
    },
    menu: {
        color: 'black',
        border: 'none'
    },
    downloadApp: {
        textTransform: 'none',
        fontSize: '14px',
        padding: '12px',
        marginTop: 40,
        borderRadius: '8px',
        boxShadow: '0 15px 30px 0 rgba(255, 106, 114, 0.4)',
        [theme.breakpoints.down('sm')]: {
            borderRadius: theme.spacing(3),
            fontSize: 17,
            fontWeight: 500,
            lineHeight: 1.41,
            letterSpacing: '-0.3px',
        },
    }
})

class HamburgerMenu extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isHamburgerMenu: false,
        }
    }

    toggleDrawer = (open, event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        this.setState({
            isHamburgerMenu: open
        })
    }

    handleInstallApp = () => {
        if (isIOS === 'iOS') {
            window.location.replace(APP_STORE_URL);
        } else {
            window.location.replace(GOOGLE_PLAY_STORE_URL);
        }
    }

    render() {
        const { classes, t } = this.props;
        const { isHamburgerMenu } = this.state;

        return (
            <>
                <Button onClick={(e) => this.toggleDrawer(true, e)}
                        style={{ minWidth: '24px', padding: '0px' }}>
                    <img src={NaviMenu} width={24} height={24}/>
                </Button>
                <SwipeableDrawer
                    anchor={'top'}
                    open={isHamburgerMenu}
                    onOpen={(e) => this.toggleDrawer(true, e)}
                    onClose={(e) => this.toggleDrawer(false, e)}
                    classes={{
                        paper: classes.menuPaper
                    }}
                >
                    <Container>
                        <List className={classes.menuList}>
                            {['', t('AppBar.introduction'), t('AppBar.effort'), t('AppBar.login'), t("signup.header.title")].map((text, index) => (
                                index === 0 ?
                                    <ListItem 
                                        key={`menu-${index}`}
                                        button
                                        style={{
                                            height: '48px',
                                            marginBottom: 40,
                                        }}
                                    >
                                        <ListItemIcon style={index === 0 ? {
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        } : { display: 'none' }}>{index === 0 ?
                                            <>
                                                <img alt={"logo"} src={Logo} style={{ height: '24px' }}/>
                                                <CloseIcon style={{ width: '30px', height: '30px' }}
                                                        onClick={(e) => this.toggleDrawer(false, e)}/>
                                            </> : null}
                                        </ListItemIcon>
                                        <ListItemText style={index !== 0 ? {
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center'
                                        } : null} primary={index !== 0 ? text : null}/>
                                    </ListItem>
                                    :
                                    <>
                                        <ListItemLink
                                            key={`menu-${index}`}
                                            primary={text}
                                            to={index === 1 ? '/introduce' : index === 2 ? '/legal-effect' : index === 3 ? '/login' : '/sign-up'}
                                            classname={classes.menu}
                                            isNested={true}
                                            noIcon={true}
                                        />
                                        <Divider key={`divider-${index}`} style={{ marginTop: '5px', marginBottom: '5px' }}/>
                                    </>
                            ))}
                        </List>
                        <CustomButton
                            label={t('HomepageImage.floatButton')}
                            className={classes.downloadApp}
                            onClick={this.handleInstallApp}
                            endIcon={
                                <img
                                    src={DownloadIcon}
                                    alt='download-mobile'
                                    style={{
                                        width: 24,
                                        height: 24,
                                        objectFit: 'none',
                                    }}
                                />
                            }
                        />
                    </Container>
                </SwipeableDrawer>
            </>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.auth.lang
});

const mapDispatchToProps = dispatch => ({
    setLanguage: (lang) => dispatch(setLanguage(lang))
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(HamburgerMenu)));
